<template>
    <div v-if="showModal" id="photo_modal" class="ui middle aligned center aligned grid" @click="close">
        <div v-if="!showPhoto" class="ui middle aligned column container">
            <div class="ui inverted segment">
                <p><span class="ui large text">업체: {{item.partnerName}} / 주문날짜: {{orderedAt}} / 주문자: {{item.orderer}}</span></p>
                <p><span class="ui large text">상품: {{item.product}} / 설치유형: {{item.partnerMemo}} / 설치기사: {{item.workerName}}</span></p>
            </div>
            <table class="ui very basic table">
                <tbody>
                    <tr>
                        <td class="collapsing" v-if="imageUrls.length > 1">
                            <button class="ui inverted icon button" @click.stop="nextImage(-1)">
                                <i class="angle left icon"></i>
                            </button>
                        </td>
                        <td>
                            <img class="ui centered image" :src="imageUrls[imageIndex]">
                        </td>
                        <td class="collapsing" v-if="imageUrls.length > 1">
                            <button class="ui inverted icon button" @click.stop="nextImage(+1)">
                                <i class="angle right icon"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="showPhoto" class="ui middle aligned column container">
            <table class="ui very basic table">
                <tbody>
                    <tr>
                        <td>
                            <img class="ui centered image" :src="imageUrl">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, showPhoto: 0, imageUrls: 0, imageIndex: 0, item: 0, worker: 0, orderedAt: 0, imageUrl: 0 }
    },
    created: function() {
        this.showModal = false;
        this.showPhoto = false;
    },
    mounted: function() {
        this.$event.set("openPhoto", this.openPhoto);
        this.$event.set("openPhotos", this.openPhotos);
        this.$event.set("openPhotoByUrl", this.openPhotoByUrl);
    },
    beforeDestroyed: function() {
        this.$event.clear("openPhoto");
        this.$event.clear("openPhotos");
        this.$event.clear("openPhotoByUrl");
    },
    methods: {
        openPhoto(item) {
            this.showModal = true;
            this.item = item;
            this.imageUrls = [ item.signUrl ];
            this.imageIndex = 0;
            this.orderedAt = new Date(item.orderedAt).format("yyyy-MM-dd(KS)");
        },
        openPhotos(item) {
            if (item.imageUrls.length > 0) {
                this.showModal = true;
                this.item = item;
                this.imageUrls = item.imageUrls;
                this.imageIndex = 0;
                this.orderedAt = new Date(item.orderedAt).format("yyyy-MM-dd(KS)");
            }
        },
        openPhotoByUrl(url) {
            this.showModal = true;
            this.showPhoto = true;
            this.imageUrl = url;
        },
        close() {
            this.showModal = false;
            this.showPhoto = false;
        },
        nextImage(add) {
            if (this.imageUrls && this.imageUrls.length > 0)
            {
                this.imageIndex += add;

                if (this.imageIndex < 0) this.imageIndex = this.imageUrls.length - 1;
                if (this.imageIndex >= this.imageUrls.length) this.imageIndex = 0;
            }
        },
        getWorker(_workerId) {
            for (const worker of this.workers) {
                if (worker._id == _workerId) {
                    return worker;
                }
            }
            return null;
        },
    },
    computed: {
        products: function() { return this.$store.getters.products; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isCenter: function() { return this.$store.getters.isCenter; },
        isPartner: function() { return this.$store.getters.isPartner; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
    },
}
</script>

<style>

#photo_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.9);
}

</style>


// WEBPACK FOOTER //
// src/components/PhotoModal.vue